<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Leasing'"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (loaded && unit) {

      <!-- Unit header -->
      <tidy-card>
        <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
          <tidy-text [header]="unit.property_name + ' · ' + unit.unit" [translate]="false" />
          <tidy-text
            [body]="displayStateLabel"
            [translate]="false"
            [ngStyle]="{ color: displayStateColor }" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/location-outline.svg'" class="body-size" />
          <tidy-text [helper]="unit.address" [translate]="false" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/bed-outline.svg'" class="body-size" />
          <tidy-text
            [helper]="(unit.bedrooms === 0 ? 'Studio' : unit.bedrooms + ' bd') + ' / ' + unit.bathrooms + ' ba · ' + unit.sqft + ' sqft · $' + unit.market_rent.toLocaleString('en-US') + '/mo market'"
            [translate]="false" />
        </tidy-row>
        <tidy-card-button (action)="shareApplicationLink()">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/chain-link.svg'"
              class="body-size" />
            <tidy-text
              [body]="'Share Application Link'" />
          </tidy-row>
        </tidy-card-button>
        @if (!isByRoom) {
          @switch (unit.state) {
            @case ('Signing') {
              <tidy-card-button (action)="sendSigningReminder()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/send.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'Send Signature Reminder'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="viewLease()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/notes.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'View Lease'" />
                </tidy-row>
              </tidy-card-button>
            }
            @case ('Occupied') {
              <tidy-card-button (action)="editCollectionSettings()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/credit-card.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'Edit Collection Settings'" />
                </tidy-row>
              </tidy-card-button>
            }
            @case ('Overdue') {
              <tidy-card-button (action)="sendRentReminder()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/send-money.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'Send Payment Reminder'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="sendLateNotice()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/alert.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'Send Late Notice'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="startPaymentPlan()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/rental-plan.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'Start Payment Plan'" />
                </tidy-row>
              </tidy-card-button>
            }
            @case ('Eviction') {
              <tidy-card-button (action)="updateEvictionStage()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/update.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'Update Stage'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="contactAttorney()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/suitcase.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'Contact Eviction Attorney'" />
                </tidy-row>
              </tidy-card-button>
            }
          }
          <tidy-card-button (action)="goToRoomSetup()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/smart-door.svg'"
                class="body-size" />
              <tidy-text
                [body]="'Split into Rooms'" />
            </tidy-row>
          </tidy-card-button>
        }
        @if (isByRoom) {
          <tidy-card-button (action)="goToRoomSetup()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/smart-door.svg'"
                class="body-size" />
              <tidy-text
                [body]="'Edit Rooms'" />
            </tidy-row>
          </tidy-card-button>
        }
      </tidy-card>

      @if (isByRoom) {

        <!-- ===== OCCUPANCY ROLLUP + YIELD ===== -->
        <tidy-card>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [body]="occupancyLabel" [translate]="false" />
            <tidy-text [body]="'$' + combinedRoomRent.toLocaleString('en-US') + '/mo combined'" [translate]="false" />
          </tidy-row>
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="'assets/svg/trending-up-outline.svg'" class="body-size" />
            <tidy-text
              [helper]="yieldDeltaLabel"
              [translate]="false"
              [ngStyle]="{ color: yieldDelta >= 0 ? '#2E7D32' : '#C62828' }" />
          </tidy-row>
        </tidy-card>

        @if (unit.screening_policy === 'every_member_every_move_in') {
          <tidy-alert>
            <tidy-row>
              <tidy-text [body]="'Every member is screened on every move-in'" />
            </tidy-row>
          </tidy-alert>
        }

        <!-- ===== ROOMS ===== -->
        <tidy-row>
          <tidy-text [title]="'Rooms'" />
        </tidy-row>
        @if (hasRoomListings) {
          <tidy-card-button (action)="goToChannelsTab()" class="arrow-to-top">
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Listings'" />
              <tidy-text [body]="listingsSummaryLabel" [translate]="false" />
            </tidy-row>
          </tidy-card-button>
        }
        @for (room of rooms; track room.space.id) {
          <tidy-card>
            @if (room.isVacant) {
              <tidy-row [alignLastItemRight]="true">
                <tidy-text [header]="room.space.name" [translate]="false" />
                <tidy-text [body]="room.space.state" [translate]="false" [ngStyle]="{ color: room.stateColor }" />
              </tidy-row>
              <tidy-row [alignLastItemRight]="true">
                <tidy-text [body]="room.vacantDaysLabel" [translate]="false" />
                @if (room.askingRentLabel) {
                  <tidy-text [body]="room.askingRentLabel" [translate]="false" />
                }
              </tidy-row>
              @for (chip of room.listingChips; track chip.label) {
                <tidy-row class="vertical-align-center">
                  <tidy-image [src]="chip.logo" [alt]="chip.label" class="header-size" />
                  <tidy-text [helper]="chip.label" [translate]="false" />
                </tidy-row>
              }
              <tidy-card-button (action)="goToListRoom(room.space)">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/rental.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'List This Room'" />
                </tidy-row>
              </tidy-card-button>
              <tidy-card-button (action)="shareRoomApplicationLink(room)">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/chain-link.svg'"
                    class="body-size" />
                  <tidy-text
                    [body]="'Share Room Application Link'" />
                </tidy-row>
              </tidy-card-button>
              @if (room.waitlistApplications.length > 0) {
                <tidy-divider />
                <tidy-row class="extra-top-padding">
                  <tidy-text [body]="'Waitlist'" />
                </tidy-row>
                @for (application of room.waitlistApplications; track application.id) {
                  <tidy-card-button (action)="goToApplicationDetail(application)" class="arrow-to-top">
                    <tidy-row class="vertical-align-center">
                      <tidy-image
                        [src]="'assets/img/account.svg'"
                        class="body-size" />
                      <tidy-text [body]="application.applicant_name" [translate]="false" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-text
                        [helper]="application.status + ' · Applied via ' + application.source"
                        [translate]="false" />
                    </tidy-row>
                  </tidy-card-button>
                }
              }
              @if (room.waitlistApplications.length === 0) {
                <tidy-row>
                  <tidy-text [helper]="'No waitlist applicants yet.'" />
                </tidy-row>
              }
            }
            @if (!room.isVacant) {
              <tidy-card-button (action)="goToLeaseLedger(room.space)" class="arrow-to-top">
                <tidy-row [alignLastItemRight]="true">
                  <tidy-text [header]="room.space.name" [translate]="false" />
                  <tidy-text [body]="room.space.state" [translate]="false" [ngStyle]="{ color: room.stateColor }" />
                </tidy-row>
                <tidy-row [alignLastItemRight]="true">
                  <tidy-text [body]="room.space.tenant_name" [translate]="false" />
                  <tidy-text [body]="room.rentLabel" [translate]="false" />
                </tidy-row>
                <tidy-row class="vertical-align-center">
                  <tidy-image [src]="'assets/svg/calendar-outline.svg'" class="body-size" />
                  <tidy-text
                    [helper]="'Lease ' + (room.space.lease_start | date:'MMM yyyy') + (room.space.lease_end ? ' – ' + (room.space.lease_end | date:'MMM yyyy') : ' · month-to-month')"
                    [translate]="false" />
                </tidy-row>
                @for (chip of room.listingChips; track chip.label) {
                  <tidy-row class="vertical-align-center">
                    <tidy-image [src]="chip.logo" [alt]="chip.label" class="header-size" />
                    <tidy-text [helper]="chip.label" [translate]="false" />
                  </tidy-row>
                }
              </tidy-card-button>
            }
          </tidy-card>
        }

        @for (common of commonSpaces; track common.id) {
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="common.name" [translate]="false" />
              <tidy-text [helper]="'Shared'" [translate]="false" />
            </tidy-row>
          </tidy-card>
        }

        <!-- ===== COMPLIANCE ===== -->
        @if (unit.occupancy_classification || complianceItems.length) {
          <tidy-row><tidy-text [title]="'Compliance'" /></tidy-row>
          <tidy-card>
            @if (unit.occupancy_classification === 'rooming_house') {
              <tidy-row>
                <tidy-text [body]="'Rooming house'" [ngStyle]="{ color: '#2196F3' }" />
              </tidy-row>
              <tidy-divider />
            }
            @for (row of complianceItems; track row.item.label) {
              <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
                <tidy-text [body]="row.item.label" [translate]="false" />
                <tidy-text
                  [body]="row.statusLabel"
                  [translate]="false"
                  [ngStyle]="{ color: row.statusColor, 'font-weight': row.isActionNeeded ? '700' : '400' }" />
              </tidy-row>
              @if (row.detailLine) {
                <tidy-row>
                  <tidy-text [helper]="row.detailLine" [translate]="false" />
                </tidy-row>
              }
            }
          </tidy-card>
        }

        <!-- ===== ROOM OPERATIONS ===== -->
        <tidy-card-button (action)="goToRoomOperations()" class="arrow-to-top">
          <tidy-row>
            <tidy-text [title]="'Room Operations'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [helper]="'Shared expenses, waitlist, and upkeep for this unit'" />
          </tidy-row>
        </tidy-card-button>
      }

      @if (!isByRoom) {
      @switch (unit.state) {

        <!-- ===== VACANT ===== -->
        @case ('Vacant') {
          <tidy-row><tidy-text [title]="'Listing channels'" /></tidy-row>
          <tidy-card>
            @for (channel of listingChannelViews; track channel.name; let first = $first) {
              <tidy-row class="vertical-align-center" [alignLastItemRight]="true" [class.extra-top-padding]="!first">
                <tidy-image [src]="channel.logo" class="header-size" />
                <tidy-text [body]="channel.name" [translate]="false" />
                <tidy-text
                  [body]="channel.status"
                  [translate]="false"
                  [ngStyle]="{ color: channel.statusColor }" />
              </tidy-row>
            }
            @if (listingChannelViews.length === 0) {
              <tidy-row>
                <tidy-text [helper]="'This unit is not listed anywhere yet.'" />
              </tidy-row>
            }
          </tidy-card>
        }

        <!-- ===== APPLICATIONS ===== -->
        @case ('Applications') {
          <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
            <tidy-text [title]="'Applications'" />
            <tidy-text [actionBody]="'Share link'" (action)="shareApplicationLink()" class="link" />
          </tidy-row>
          @if (applications.length === 0) {
            <tidy-alert><tidy-row><tidy-text [body]="'No applications yet for this unit.'" /></tidy-row></tidy-alert>
          }
          @for (application of applications; track application.id) {
            <tidy-card>
              <tidy-card-button (action)="goToApplicationDetail(application)" class="arrow-to-top">
                <tidy-row [alignLastItemRight]="true">
                  <tidy-text [header]="application.applicant_name" [translate]="false" />
                  <tidy-text [body]="application.status" [translate]="false" />
                </tidy-row>
                <tidy-row class="vertical-align-center">
                  <span [ngStyle]="{'width':'8px','height':'8px','border-radius':'50%','background-color': screeningColor(application),'margin-right':'6px','flex-shrink':'0'}"></span>
                  <tidy-text
                    [helper]="screeningLabel(application) + (application.screening.income_to_rent_ratio ? ' · ' + application.screening.income_to_rent_ratio + 'x rent' : '')"
                    [translate]="false" />
                </tidy-row>
                <tidy-row>
                  <tidy-text [helper]="'via ' + application.source" [translate]="false" />
                </tidy-row>
              </tidy-card-button>
            </tidy-card>
          }
        }

        <!-- ===== SIGNING ===== -->
        @case ('Signing') {
          <tidy-row><tidy-text [title]="'Lease pending finalization'" /></tidy-row>
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Tenant'" />
              <tidy-text [body]="unit.tenant_name" [translate]="false" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Term'" />
              <tidy-text [body]="(unit.lease_start | date:'MMM d, yyyy') + ' – ' + (unit.lease_end | date:'MMM d, yyyy')" [translate]="false" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Rent / Deposit'" />
              <tidy-text [body]="'$' + unit.rent.toLocaleString('en-US') + ' / $' + unit.deposit.toLocaleString('en-US')" [translate]="false" />
            </tidy-row>
            <tidy-divider />
            <tidy-row class="extra-top-padding"><tidy-text [helper]="'E-signature status'" /></tidy-row>
            @for (party of unit.signing; track party.party) {
              <tidy-row [alignLastItemRight]="true">
                <tidy-text [body]="party.party" [translate]="false" />
                <tidy-text
                  [body]="party.status + (party.date ? ' · ' + (party.date | date:'MMM d') : '')"
                  [translate]="false"
                  [ngStyle]="{ color: party.status === 'Signed' ? '#2E7D32' : '#F9A825' }" />
              </tidy-row>
            }
          </tidy-card>
        }

        <!-- ===== OCCUPIED ===== -->
        @case ('Occupied') {
          <tidy-row><tidy-text [title]="'Tenant & lease'" /></tidy-row>
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="unit.tenant_name" [translate]="false" />
              <tidy-text [body]="unit.rent_status" [ngStyle]="{ color: '#2E7D32' }" [translate]="false" />
            </tidy-row>
            <tidy-row class="vertical-align-center">
              <tidy-image [src]="'assets/svg/calendar-outline.svg'" class="body-size" />
              <tidy-text
                [helper]="'Lease ' + (unit.lease_start | date:'MMM yyyy') + ' – ' + (unit.lease_end | date:'MMM yyyy') + ' · $' + unit.rent.toLocaleString('en-US') + '/mo'"
                [translate]="false" />
            </tidy-row>
            <tidy-row class="vertical-align-center">
              <tidy-image [src]="'assets/svg/cash-outline.svg'" class="body-size" />
              <tidy-text [helper]="'Next rent due ' + (unit.next_due | date:'MMM d, yyyy')" [translate]="false" />
            </tidy-row>
          </tidy-card>

          <tidy-row><tidy-text [title]="'Automatic Collection Settings'" /></tidy-row>
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Autopay'" />
              <tidy-text
                [body]="unit.collection.autopay ? 'On' : 'Off'"
                [ngStyle]="{ color: unit.collection.autopay ? '#2E7D32' : '#999' }"
                [translate]="false" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Payment method'" />
              <tidy-text [body]="unit.collection.payment_method" [translate]="false" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Due day'" />
              <tidy-text [body]="'1st of the month'" [translate]="false" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Late fee'" />
              <tidy-text [body]="unit.collection.late_fee" [translate]="false" />
            </tidy-row>
          </tidy-card>

          <tidy-row><tidy-text [title]="'Recent payments'" /></tidy-row>
          <tidy-card>
            @for (payment of unit.payments; track payment.date) {
              <tidy-row [alignLastItemRight]="true">
                <tidy-text [body]="(payment.date | date:'MMM d, yyyy') + ' · ' + payment.method" [translate]="false" />
                <tidy-text [body]="'$' + payment.amount.toLocaleString('en-US') + ' · ' + payment.status" [translate]="false" [ngStyle]="{ color: '#2E7D32' }" />
              </tidy-row>
            }
          </tidy-card>
        }

        <!-- ===== OVERDUE ===== -->
        @case ('Overdue') {
          <tidy-row><tidy-text [title]="'Rent overdue'" /></tidy-row>
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="unit.tenant_name" [translate]="false" />
              <tidy-text [body]="unit.days_overdue + ' days overdue'" [ngStyle]="{ color: '#EF6C00' }" [translate]="false" />
            </tidy-row>
            <tidy-divider />
            <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
              <tidy-text [body]="'Past-due balance'" />
              <tidy-text [body]="'$' + unit.amount_due.toLocaleString('en-US')" [ngStyle]="{ color: '#C62828' }" [translate]="false" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Includes late fee'" />
              <tidy-text [body]="'$' + (unit.late_fee_applied || 0).toLocaleString('en-US')" [translate]="false" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Original due'" />
              <tidy-text [body]="(unit.next_due | date:'MMM d, yyyy')" [translate]="false" />
            </tidy-row>
          </tidy-card>

          <tidy-row><tidy-text [title]="'Payment history'" /></tidy-row>
          <tidy-card>
            @for (payment of unit.payments; track payment.date) {
              <tidy-row [alignLastItemRight]="true">
                <tidy-text [body]="(payment.date | date:'MMM d, yyyy') + ' · ' + payment.method" [translate]="false" />
                <tidy-text [body]="'$' + payment.amount.toLocaleString('en-US') + ' · ' + payment.status" [translate]="false" />
              </tidy-row>
            }
          </tidy-card>
        }

        <!-- ===== EVICTION ===== -->
        @case ('Eviction') {
          <tidy-row><tidy-text [title]="'Eviction in progress'" /></tidy-row>
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="unit.tenant_name" [translate]="false" />
              <tidy-text [body]="unit.eviction_stage" [ngStyle]="{ color: '#C62828' }" [translate]="false" />
            </tidy-row>
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [body]="'Balance owed'" />
              <tidy-text [body]="'$' + (unit.amount_due || 0).toLocaleString('en-US')" [translate]="false" />
            </tidy-row>
          </tidy-card>

          <tidy-row><tidy-text [title]="'Process tracker'" /></tidy-row>
          <tidy-card>
            @for (step of unit.eviction_steps; track step.label) {
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="step.done ? 'assets/svg/checkmark-circle-outline.svg' : 'assets/svg/ellipse-outline.svg'"
                  class="body-size" />
                <tidy-text
                  [body]="step.label + (step.date ? ' · ' + (step.date | date:'MMM d, yyyy') : '')"
                  [translate]="false"
                  [ngStyle]="{ color: step.done ? '#1E2125' : '#999' }" />
              </tidy-row>
            }
          </tidy-card>
        }
      }
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
